import { Deserializable } from "../interfaces/deserialize";
import * as _ from "lodash";
import { PackModel } from "./pack.model";
import { Constants } from "../../features/models/constants/_constants";
import { ManualModel } from "./manual.model";
import { QuotationModel } from "./quotation.model";

export type AvailableSetups = "windows" | "mac" | "macM1";
export class ToolModel implements Deserializable {
	_id?: string;
	name = { es: "", en: "", fr: "", zh: "", it: "", pt: "", jp: "", tr: "" };
	ekonMainId?: string;
	ekonRenewalId?: string;
	subscriptionId?: string;
	softwareUrl?: string;
	product!: string;
	ctaContable?: string;
	shortDescription = {
		es: "",
		en: "",
		fr: "",
		zh: "",
		it: "",
		pt: "",
		jp: "",
		tr: "",
	};
	longDescription = {
		es: "",
		en: "",
		fr: "",
		zh: "",
		it: "",
		pt: "",
		jp: "",
		tr: "",
	};
	image: { logo: any; detail: any } = { logo: "", detail: "" };
	manuals?: Array<any> = [];
	quotations?: Array<any> = [];
	packs?: Array<PackModel>;
	createdAt?: string;
	updatedAt?: string;
	disabled?: string | boolean | null;
	visible?: boolean;
	noVisibleBuyer: boolean = false;
	sort: { packs: number } = { packs: 0 };
	setups?: Array<{
		blobId: string;
		tag: AvailableSetups;
	}>;
	depends?: Array<string>;
	modalities?: Array<string>;
	hasPremiumPack?: boolean;

	deserialize(obj: any) {
		Object.assign(this, obj);
		if (!this.hasOwnProperty("disabled")) {
			this.disabled = false;
		} else {
			this.disabled = obj.disabled !== null;
		}
		if (this.packs && Array.isArray(this.packs) && this.packs.length > 0) {
			this.packs = this.packs.map((packModel) => {
				return new PackModel().deserialize(packModel);
			});
		}
		return this;
	}

	public checkIfLanguagesIsValid(code: "es" | "en" | "fr" | "zh" | "it" | "pt" | "jp" | "tr"): boolean {
		return this.name[code] !== "" && this.shortDescription[code] !== "" && this.longDescription[code] !== "";
	}

	public checkForOneShotPayment(): boolean {
		if (this.packs && Array.isArray(this.packs) && this.packs.length > 0) {
			const packCore = this.packs.filter((pack: PackModel) => pack.type === Constants.PACK_TYPE_NAMES.core)[0];

			if (packCore !== undefined) {
				return packCore.paymentType === Constants.PAYMENT_TYPE_NAMES.one_shot;
			} else {
				const minPackPrice = this.packs.reduce((acc, curr) => {
					if (acc.getPrice() < curr.getPrice()) {
						return acc;
					}
					return curr;
				});
				return minPackPrice.paymentType === Constants.PAYMENT_TYPE_NAMES.one_shot;
			}
		}
		return true;
	}

	public getId(): string | null {
		return this._id ?? null;
	}

	public getName(language?: "es" | "en" | "fr" | "zh" | "it" | "pt" | "jp" | "tr"): string {
		let auxName: string | undefined = undefined;
		for (const key of Object.keys(this.name)) {
			if (key === language) {
				auxName = this.name[key];
			}
		}
		return auxName !== undefined ? auxName : this.name.en;
	}

	public getShortDescription(language?: "es" | "en" | "fr" | "zh" | "it" | "pt" | "jp" | "tr"): string {
		if (!language) return this.shortDescription.en;
		else return this.shortDescription[language] !== undefined ? this.shortDescription[language] : this.shortDescription.en;
	}

	public getLongDescription(language?: "es" | "en" | "fr" | "zh" | "it" | "pt" | "jp" | "tr"): string {
		let auxShortDescription: string = "en";
		for (const key of Object.keys(this.longDescription)) {
			if (key === language) {
				auxShortDescription = this.longDescription[key];
			}
		}
		return auxShortDescription !== undefined ? auxShortDescription : this.longDescription.en;
	}

	public getManuals(): Array<ManualModel> {
		return this.manuals ?? [];
	}

	public getQuotation(): Array<QuotationModel> {
		return this.quotations ?? [];
	}

	public getPacks(): Array<PackModel> {
		return this.packs ? this.packs : [];
	}

	public getMainPrice(): string {
		if (this.packs && Array.isArray(this.packs) && this.packs.length > 0) {
			const packCore = this.packs.filter((pack: PackModel) => pack.type === Constants.PACK_TYPE_NAMES.core)[0];

			if (packCore !== undefined) {
				return packCore.getPrice();
			} else {
				const minPackPrice = this.packs.reduce((acc, curr) => {
					if (acc.getPrice() < curr.getPrice()) {
						return acc;
					}
					return curr;
				});
				return minPackPrice.getPrice();
			}
		}
		return "0";
	}

	public getMainImage(): string {
		if (this.image && this.image.logo) {
			return this.image.logo.uri ? this.image.logo.uri : "";
		}
		return "";
	}

	public getAdditionalPrice(): string | 0 {
		const packs = this.packs?.filter((pack) => pack.type !== Constants.PACK_TYPE_NAMES.core);

		if (packs && packs.length > 0) {
			const pack = packs[0];
			return pack.packPrice[0].amount;
		} else {
			return 0;
		}
	}

	public hasTrialPack(): boolean {
		const trialTool = _.find(this.packs, ["trial.hasTrial", true]);
		return trialTool !== undefined;
	}
}
